import React from 'react';
import { getPrimaryExperienceUrl } from './app-dux/interaction-dux.js';

const ActivationComponent = React.lazy( () => import( './components/route-activate/index.jsx' ) );
const ChoiceComponent = React.lazy( () => import( './components/route-choice/index.jsx' ) );
const LoginComponent = React.lazy( () => import( './components/route-login/index.jsx' ) );
const InteractionComponent = React.lazy( () => import( './components/route-interaction/index.jsx' ) );
const ForgotUsernameComponent = React.lazy( () => import( './components/route-forgot-username/index.jsx' ) );
const ForgotPasswordComponent = React.lazy( () => import( './components/route-forgot-password/index.jsx' ) );
const SelectMethodComponent = React.lazy( () => import( './components/route-select-method/index.jsx' ) );
const EmailVerificationComponent = React.lazy( () => import( './components/route-email-verify/index.jsx' ) );
const ErrorComponent = React.lazy( () => import( './components/route-error/genericError.jsx' ) );
const ResetVerificationComponent = React.lazy( () => import( './components/route-reset-verify/index.jsx' ) );
const SetPasswordComponent = React.lazy( () => import( './components/route-set-password/index.jsx' ) );
const UpdatePasswordComponent = React.lazy( () => import( './components/route-update-password/index.jsx' ) );
const CollectRecoveryComponent = React.lazy( () => import( './components/route-collect-recovery-info/index.jsx' ) );
const InactiveComponent = React.lazy( () => import( './components/route-inactive/index.jsx' ) );
const LogoutComponent = React.lazy( () => import( './components/route-logout/index.jsx' ) );

const Bundle = ( Component ) => (
	( props ) => (
		<Component { ...props } />
	)
);

// Maintaining Duplicate routes until we use just umbrella part.
export const routes = [
	{
		title: 'kadhavu.pageTitle.login',
		pattern: '/login',
		requiresAuth: false,
		requireBackButton: false,
		render: ( props ) => (
			<LoginComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.login',
		pattern: '/door/login',
		requiresAuth: false,
		requireBackButton: false,
		render: ( props ) => (
			<LoginComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.choice',
		pattern: '/choose',
		requiresAuth: false,
		requireBackButton: false,
		render: ( props ) => (
			<ChoiceComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.choice',
		pattern: '/door/choose',
		requiresAuth: false,
		requireBackButton: false,
		render: ( props ) => (
			<ChoiceComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.login',
		pattern: '/login/:interactionId',
		requiresAuth: false,
		requireBackButton: false,
		render: ( props ) => (
			<InteractionComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.login',
		pattern: '/door/login/:interactionId',
		requiresAuth: false,
		requireBackButton: false,
		render: ( props ) => (
			<InteractionComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.choice',
		pattern: '/choose/:interactionId',
		requiresAuth: false,
		requireBackButton: false,
		render: ( props ) => (
			<InteractionComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.choice',
		pattern: '/door/choose/:interactionId',
		requiresAuth: false,
		requireBackButton: false,
		render: ( props ) => (
			<InteractionComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.activate',
		pattern: '/activate',
		requiresAuth: false,
		requireBackButton: true,
		render: ( props ) => (
			<ActivationComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.activate',
		pattern: '/door/activate',
		requiresAuth: false,
		requireBackButton: true,
		render: ( props ) => (
			<ActivationComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.forgotUsername',
		pattern: '/forgot-username',
		requiresAuth: false,
		requireBackButton: true,
		render: ( props ) => (
			<ForgotUsernameComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.forgotUsername',
		pattern: '/door/forgot-username',
		requiresAuth: false,
		requireBackButton: true,
		render: ( props ) => (
			<ForgotUsernameComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.forgotPassword',
		pattern: '/forgot-password',
		requiresAuth: false,
		requireBackButton: true,
		render: ( props ) => (
			<ForgotPasswordComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.forgotPassword',
		pattern: '/door/forgot-password',
		requiresAuth: false,
		requireBackButton: true,
		render: ( props ) => (
			<ForgotPasswordComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.methodOfContact',
		pattern: '/method-of-contact',
		requiresAuth: false,
		requireBackButton: true,
		render: ( props ) => (
			<SelectMethodComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.methodOfContact',
		pattern: '/door/method-of-contact',
		requiresAuth: false,
		requireBackButton: true,
		render: ( props ) => (
			<SelectMethodComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.emailExpired',
		pattern: '/email-expired/:token',
		requiresAuth: false,
		requireBackButton: false,
		render: ( props ) => (
			<EmailVerificationComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.emailExpired',
		pattern: '/door/email-expired/:token',
		requiresAuth: false,
		requireBackButton: false,
		render: ( props ) => (
			<EmailVerificationComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.resetExpired',
		pattern: '/reset-expired/:token',
		requiresAuth: false,
		requireBackButton: false,
		render: ( props ) => (
			<ResetVerificationComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.resetExpired',
		pattern: '/door/reset-expired/:token',
		requiresAuth: false,
		requireBackButton: false,
		render: ( props ) => (
			<ResetVerificationComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.setPassword',
		pattern: '/set-password/:interactionId',
		requiresAuth: false,
		requireBackButton: false,
		render: ( props ) => (
			<InteractionComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.setPassword',
		pattern: '/door/set-password/:interactionId',
		requiresAuth: false,
		requireBackButton: false,
		render: ( props ) => (
			<InteractionComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.setPassword',
		pattern: '/set-password',
		requiresAuth: false,
		requireBackButton: false,
		render: ( props ) => (
			<SetPasswordComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.updatePassword',
		pattern: '/update-password',
		requiresAuth: false,
		requireBackButton: false,
		render: ( props ) => (
			<UpdatePasswordComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.updatePassword',
		pattern: '/door/update-password',
		requiresAuth: false,
		requireBackButton: false,
		render: ( props ) => (
			<UpdatePasswordComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.setPassword',
		pattern: '/door/set-password',
		requiresAuth: false,
		requireBackButton: false,
		render: ( props ) => (
			<SetPasswordComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.recoveryInfo',
		pattern: '/recovery-info',
		requiresAuth: true,
		requireBackButton: false,
		render: ( props ) => (
			<CollectRecoveryComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.recoveryInfo',
		pattern: '/door/recovery-info',
		requiresAuth: true,
		requireBackButton: false,
		render: ( props ) => (
			<CollectRecoveryComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.error',
		pattern: '/error',
		requiresAuth: false,
		requireBackButton: false,
		render: ( props ) => (
			<ErrorComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.error',
		pattern: '/door/error',
		requiresAuth: false,
		requireBackButton: false,
		render: ( props ) => (
			<ErrorComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.inactive',
		pattern: '/inactive',
		requiresAuth: false,
		requireBackButton: true,
		render: ( props ) => (
			<InactiveComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.inactive',
		pattern: '/door/inactive',
		requiresAuth: false,
		requireBackButton: true,
		render: ( props ) => (
			<InactiveComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.logout',
		pattern: '/logout',
		requiresAuth: false,
		requireBackButton: false,
		render: ( props ) => (
			<LogoutComponent { ...props } />
		)
	},
	{
		title: 'kadhavu.pageTitle.logout',
		pattern: '/door/logout',
		requiresAuth: false,
		requireBackButton: false,
		render: ( props ) => (
			<LogoutComponent { ...props } />
		)
	}
];

export const getMiddleware = ( store ) => {
	return [
		// Redirect / to login
		async ( action, nextRoute, prevRoute ) => {
				if ( 
					nextRoute.pathname  === '' || 
					nextRoute.pathname === '/' || 
					nextRoute.pathname === '/login' || 
					nextRoute.pathname === '/door' || 
					nextRoute.pathname === '/door/login' ||
					nextRoute.pathname ===  '/choose' ||
					nextRoute.pathname ===  '/door/choose'
				) {
					if ( 
						!nextRoute.state.params || 
						Object.entries( nextRoute.state.params ).length === 0 && 
						!nextRoute.state.params[ 'interactionId' ] 
					) {
						if ( sessionStorage.getItem( 'interactionId' ) ) {
							if ( nextRoute.pathname === '/choose' || nextRoute.pathname === '/door/choose' ) {
								action.ok();
							} else if ( nextRoute.pathname !== '/door/login' ) {
								action.redirect( '/door/login' );
							} else {
								action.ok();
							}
						} else {
							const primaryExperienceUrl = await store.dispatch( getPrimaryExperienceUrl() );

							if ( primaryExperienceUrl ) {
								// if you want to run this locally, comment this next line and add action.ok();
								window.location = primaryExperienceUrl;
								// action.ok();
							} else {
								action.redirect( '/error' );
							}
						}
					}
			} else {
				action.ok();
			}
        },
		// Load Bundles
		( action, nextRoute, prevRoute ) => {
			const { match } = nextRoute;

			if (
				match &&
				!match.render &&
				typeof match.load === 'function'
			) {

				match.load( ( asyncModule ) => {
					match.render = Bundle( asyncModule.default ? asyncModule.default : asyncModule );
					action.ok();
				} );
			} else {
				action.ok();
			}
		}
	];
};